import React,{ useState,useEffect} from 'react'
import DataTable from '../Components/Molecules/Table/DataTable'
import { FaArrowLeft } from 'react-icons/fa'; 
import _ from "lodash";
import {
  CalendarInput,
  FormDropdown,
  FormField,
  FormFieldMail,
  FormTextArea,
} from "../Components/Molecules/FormField/FormField";
import { useFormik } from "formik";
import * as Yup from "yup";
import Card from "../Components/Atoms/Card/Card";
import ErrorLabel from "../Components/Atoms/ErrorLabel/ErrorLabel";
import thosuandSeparator from "../Helpers/thousandSeparator";
import {
  CancelButton,
  PrimaryButton,
} from "../Components/Atoms/Button/Button";
import RadioButton from "../Components/Atoms/RadioButton/RadioButton";
import { SingleDatePicker } from "../Components/Atoms/SingleDatePicker/SingleDatePicker";
//import styles from "./Dashboard.module.scss";
import HBar from "../Components/Bars/Bars";
import {apply_loan,customer_list,branch_list,lead_list,get_master_data} from "../Enums/api_constunts"
import {postMethod} from "../Helpers/services"
import { showToast } from "../Components/Atoms/ToastNotifier/ToastNotifier";
import { useSelector } from "react-redux";
import LoanApplicationForm from './loanForm/LoanApplicationForm';
import CustomerDetails from "./CustomerDetails"
export default function LeadsList() {
const [branchList, setBranchList] = useState([])
const  [selectedRow, setSelectedRow] = useState(null)
const [OpenForm,setOpenForm] = useState(0)
const userData = useSelector((state) => state.auth.user);
const [filterData,setFilterData] = useState({"page":1,"per_page":25,"role_id":[3],"search_string":""}
)

const [serviceTypes,setServiceTypes] = useState([])
const [selectedServiceType, setSelectedServiceType] = useState(null)
const getMasterData = ()=>{
  let postData = {"categories":["md_service_types"]};
  //values["tenant_id"] = _.get(selectedTenant,"id");
   postMethod(get_master_data,postData).then((res)=>{
    

   let md_service_types =   _.get(res,"result.md_service_types",[]).map((item)=>{
      item["label"] =  item["name"]
      
      return item
    });
    setServiceTypes(md_service_types)
    
  })
}
useEffect(()=>{
  getMasterData()
},[])
  const columnDefs = [
    { headerName: "ID", field: "index" ,width: 80},
    { headerName: "Tfs Id", field: "tfs_id" ,width: 80},
    { headerName: "Product", field: "detail_of_service.name", minWidth:150},
    { headerName: "Customer Name", field: "customer_details.name",minWidth:150 },
    { headerName: "Created Date", field: "created_on",minWidth:150 },
    { headerName: "Status", field: "status_details.name",minWidth:150 },
   
  ];

  columnDefs.push( { headerName: "Actions", field: "actions",maxWidth:10000 },)

  const [isSpinner, setIsSpinner] = useState(false);
  const handleSubmit = (values) => {
    setIsSpinner(true);
    
     values["tenant_id"] = _.get(selectedTenant,"id");
     values["user_id"] = _.get(selectedUser,"id");
     values["service_type_id"] = _.get(selectedServiceType,"id");

     postMethod(apply_loan,values).then((res)=>{
      console.log(res)
      setOpenForm(0)
      setIsSpinner(false);
      setSelectedUser(null)
      setSelectedServiceType(null)
      setOpenForm(0)
      showToast("success",_.get(res, "message","Something went wrong!"))
    }).catch ((error)=>{
      showToast("error",_.get(error, "message","Something went wrong!"))
      setIsSpinner(false);

    })
  };

  const [selectedTenant, setSelectedTenant ] = useState(()=>{
    if(_.get(userData, "tenant_details",null) !=null){
        return { ...userData["tenant_details"], "label":userData["tenant_details"]["name"] }
     
      
    }else{
      return null
    }
      
  })
  const getBranchList = ()=>{
    let postData = {
      "search_string": "",
      "page": 1,
      "per_page": 100,
      "created_on": "",
      "created_to": "",
      "sort_by": "id",
      "sort_order": "desc",
      "status_ids": []
    }
    postMethod(branch_list,postData).then((res)=>{
      if(_.get(res, "list.length") >0){
        let list = res["list"].map((item)=>{
          item["label"] =  item["name"]
          
          return item
        });
        setBranchList(list);
      }
      
    })

  }
  useEffect(()=>{
    //if(OpenForm ==1 && _.get(userData,"role_id") ==1){
      getBranchList();
    //}
    
  },[OpenForm])

  useEffect(()=>{
    
     
      get_users()
    
    
  },[selectedTenant])
  

  /*
  
  {
  "email": "user@example.com",
  "first_name": "string",
  "last_name": "string",
  "mobile_no": "string",
  "experience": 0,
  "profile_image": "string",
  "role_id": 0,
  "tenant_id": 0
}
  */
 let formData = {
  service_type_id:  Yup.string()
    .matches(/^[0-9]+$/, "Only numbers are allowed")
  
}
let initialValues ={
  
  service_type_id: "",
  tenant_id:_.get(selectedTenant,"name","somthing")
  
}
if(_.get(userData,"role_id") ==1){
  formData["tenant_id"] = Yup.string()
  .required("Branch is required")
  //.matches(/^[1-9 + -]+$/, "Only numbers are allowed")
  //initialValues["tenant_id"] = _.get(selectedTenant,"name","somthing")
}

  let formik = useFormik({
    initialValues:initialValues,
    validationSchema: Yup.object(formData),
    onSubmit: handleSubmit,
    validateOnBlur: true,
    validateOnChange: true,
  });

  
  const getDetails = (row,type='')=>{
   
    setSelectedRow(row)
    if(type=="SHOW_DETAILS"){
      setOpenForm(2)
    }else{
      setOpenForm(1)
    }
    

  }

  useEffect(()=>{
    if(OpenForm ==0){
      formik.resetForm();
      setSelectedRow(null)
    }
   
  },[OpenForm])
  
  const [usersList,setUsersList] = useState([])
  const [selectedUser, setSelectedUser ]  = useState(null)
  const get_users = (text)=>{

    //customer_list
    let postData = {
      "search_string": text,
      "page": 1,
      "per_page": 100,
      "created_on": "",
      "created_to": "",
      "sort_by": "id",
      "sort_order": "desc",
      "role_id": [3]
    }
    if(_.get(userData, "role_id") ==1){
      if(_.get(selectedTenant, "id")){
        postData["tenant_id"] = [_.get(selectedTenant, "id")]
      }
    }else{
      postData["tenant_id"] = [_.get(userData, "tenant_id")]
           
    }
    
    postMethod(customer_list,postData).then((res)=>{
      
      if(_.get(res, "result.list.length") >0){
        let list = res["result"]["list"].map((item)=>{
          item["label"] =  item["name"]
          
          return item
        });
        
        setUsersList(list);
      }
      
    })


  }
  
  return (
    <div>
      <div className="d-flex align-items-center mb-3">
      {OpenForm>0 && <div style={{"cursor":"pointer"}} onClick={()=>{setOpenForm(0)}} className="mr-1000 cursor-pointer arrow"><FaArrowLeft size={20}   /></div>} {/* Back arrow icon */}
      

       <h3>
       {OpenForm ==0&&<>{_.get(userData,"role_id")==5?"Loan Applications":"Leads"}</>}
      {OpenForm ==1&&<>
      
        {_.get(selectedRow,"id")?"Fill Customer Data":""}
      
      </>}
      {OpenForm ==2&&<>Details</>}
      </h3>
      </div>
        <div className={'mt-3'}>
           {OpenForm ==0 && <DataTable loaded_from="LEADS_LIST" columnDefs={columnDefs} apiUrl={lead_list} setFilterData={setFilterData} filterData={filterData} setOpenForm={(v)=>{ setOpenForm(1)}} editRow={(item,action_type)=>{getDetails(item,action_type)}} showCreateBtn={false } />}
          
          {/*Create form 
          
          email: "",
      first_name: "",
      last_name: "",
      mobile_no: "",
      experience: "",
      role_id: 3,
          
          */}
          { OpenForm ==1 && _.get(selectedRow,"id")&& <>
          
            
            <LoanApplicationForm loanApplicationId={selectedRow["customer_id"]} close_me={setOpenForm}/>
          
          </> }

          { OpenForm ==2 && _.get(selectedRow,"customer_id") && <>
            <CustomerDetails backAction={()=>{setOpenForm(0)}} customer_data={{"id":selectedRow["customer_id"]}}/>
         
         
        </>}
        </div>
    </div>
  )
}
